// extracted by mini-css-extract-plugin
export default {"container":"UGkRktwcyUeNhK6y7LAf","label":"hJaSIsc5FITapugzrOx4","value":"r5ugqO_ewIfNazFbQ48L"};